/**
 * Lightweight OrbitTransaction representation used by grouped list responses.
 * Contains transaction hash, event name, and project info for display.
 */
export class OrbitTransactionGroupedItem {
  transactionHash: string | null = null
  eventname: string | null = null
  idOrbitProjectPk: number | null = null
  projectHash: string | null = null
  projectTitle: string | null = null
  networkIdentifier: string | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null
}
